<template>
    <a-form layout="vertical" class='ant-advanced-search-form'>
        <a-row :gutter="24">
            <a-col 
                v-for="(item,i) in searchOption" 
                v-bind="layout == 'small' ? small_layout : default_layout" 
                :key="i" 
                :style="{ display: i < count ? 'block' : 'none' }"
            >
                <a-form-item 
                    :label=" $t('search.' + item.name) + ':'" 
                    :label-col="{ xs:{span: 5},sm:{span:5},md:{span:4},lg:{span:4}}" 
                    :wrapper-col="{ xs:{span: 21},sm:{span:21},md:{span:19},lg:{span:19} }"
                >
                    <a-input size="small" @blur="onSearch" :placeholder="$t('search.' + item.placeholder)" v-model.trim="item.value" v-if="item.type=='input'"></a-input>
                    <a-select  v-if="item.type=='selector'"  :placeholder="$t('search.' + item.placeholder)" size="small" @change="onSearch" :allowClear="true" v-model="item.value">
                        <a-select-option v-for="selectItem in item.source" :key="selectItem.value">{{selectItem.name}}</a-select-option>
                    </a-select>

                    <template v-if="item.type=='orgChooser'">
                        <z-org-chooser :option="item.option" @directChange="directChange" @orgSelect="orgSelect"></z-org-chooser>
                    </template>

                    <template v-if="item.type=='deviceTypeChooser'">
                        <z-device-type-chooser @deviceModelChange="deviceModelChange" :option="item.option"></z-device-type-chooser>
                    </template>

                    <a-select :placeholder="$t('search.' + item.placeholder)"  @change="onSelectChange" :allowClear="true" size="small" v-if="item.type=='custom'" v-model="item.matchValue"  style="width:30%">
                        <a-select-option v-for="searchType in item.searchTypeData" :value="searchType.paramName" :key="item.name + searchType.key">{{$t('search.' + searchType.key)}}</a-select-option>
                    </a-select>

                    <a-input :placeholder="$t('search.' + item.placeholder)"  @blur="onSearch" v-if="item.type=='custom' && (!item.matchValue || item.matchValue == '')" size="small" style="width:70%" disabled></a-input>

                    <template v-for="searchType in item.searchTypeData">
                        <template v-if="searchType.paramName == item.matchValue">
                            <a-input-number   @blur="onSearch" size="small" v-model.number="searchType.value" v-if="searchType.type == 'input'" style="width:70%" :disabled="searchType.disabled" :key="'sub_' + item.name + searchType.key"></a-input-number>
                            <span v-if="searchType.type == 'inputRange'" :key="'sub_' + item.name + searchType.key">
                                <a-input-number @blur="onPowerChange(searchType)" size="small" v-model="searchType.value[0]" style=" width: 27%; text-align: center" placeholder="最小" />
                                <a-input size="small" style=" width: 5%; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="~" disabled />
                                <a-input-number  @blur="onPowerChange(searchType)" size="small" v-model="searchType.value[1]" style="width: 27%; text-align: center; border-left: 0" placeholder="最大" />
                            </span>

                            <a-date-picker @openChange="openChange" @change="timeChange"  :disabledDate="disabledDate" size="small" v-model="searchType.value" :placeholder="$t('search.选择日期')" v-if="searchType.type == 'datePicker'" style="width:70%" :key="'sub_' + item.name + searchType.key"></a-date-picker>
                            <a-range-picker  
                                @openChange="openChange"  
                                @change="timeChange" 
                                size="small" 
                                v-model="searchType.value" 
                                v-if="searchType.type == 'rangePicker'" 
                                :ranges="{
                                    [$t('global.today')]: [$moment().startOf('day'), $moment()],
                                    [$t('global.lastThreeDays')]: [$moment().subtract('days', 2).startOf('day'), $moment()],
                                    [$t('global.lastSevenDays')]: [$moment().subtract('days', 6).startOf('day'), $moment().startOf('day')],
                                    [$t('global.lastThirtyDays')]: [$moment().subtract('days', 29).startOf('day'), $moment().startOf('day')],
                                    [$t('global.thisWeek')]: [$moment().startOf('week'), $moment()],
                                    [$t('global.thisMounth')]: [$moment().startOf('month'), $moment()]
                                }" 
                                :disabledDate="disabledDate" 
                                showTime
                                format="YYYY/MM/DD HH:mm:ss" 
                                style="width:70%" 
                                :key="'sub_' + item.name + searchType.key">
                            </a-range-picker>
                        </template>
                    </template>
                </a-form-item>
            </a-col>
            <a-col style="margin-bottom:24px" :md="{span:24}" :lg="{span:6}">
                <a-button size="small" type='primary' @click="handleSearch">{{$t('alarm.search')}}</a-button>
                <a :style="{ marginLeft: '8px', fontSize: '12px' }" @click="toggle" v-if="searchOption.length > 2">
                    <span v-if="expand">{{$t('alarm.packUp')}}</span>
                    <span v-else>{{$t('alarm.moreSearchType')}}</span>
                    <a-icon :type="expand ? 'up' : 'down'"/>
                </a>
            </a-col>
        </a-row>
    </a-form>
</template>


<script>
    import ZOrgChooser from '@/components/common/OrgChooser.vue'
    import ZDeviceTypeChooser from '@/components/common/DeviceTypeChooser.vue'
    // import moment from 'moment'

    export default {
        props:["searchOption","layout"],
        data() {
            return {
                expand: false,
                typeChooserOption: {
                    showDirect: true,
                    allowClear: true,
                    value: ''
                },
                default_layout: {
                    xs:{span:24},
                    sm: { span: 24 },
                    md: { span: 8 },
                    lg: { span: 8 },
                },
                small_layout: {
                    xs:{span:24},
                    sm: { span: 24 },
                    md: { span: 12 },
                    lg: { span: 8 },
                }
            }
        },
        components: {
            ZOrgChooser,
            ZDeviceTypeChooser
        },
        mounted () {
          console.log(this.searchOption)
        },
        computed: {
            count() {
                return this.expand ? 10 : 2
            }
        },
        methods: {
            // moment,
            // 不可选择的时间， 未来的时间 今天 || 今天之后
            disabledDate (date) {
                // console.log(date)
                return date && date > this.$moment()
            },
            onSelectChange (e) {
                // console.log(e)
                // console.log(option)
                // console.log(this.searchOption)
                if (e === undefined) {
                    this.onSearch()
                }
            },
            onPowerChange (data) {
                // console.log(data)
                if (data.value && data.value.length === 2) {
                    if (data.value[0] > 0 && data.value[0] < data.value[1]) {
                        this.onSearch()
                    }
                }
            },
            timeChange (e) {
                // console.log(e)
                if (e === null || e.length === 0) {
                    this.onSearch()
                }
            },
            handleSearch() {
                let params = {};
                this.searchOption.map(function(item) {
                    if(item.type != "custom"){
                        if(item.type == "orgChooser"){
                            if(item.option.value !== ""){
                                params["orgMatchType"] = item.option.directFlag ? 'eq' : 'll'
                                params[item.key] = item.option.value
                            }
                        }else if(item.type == "deviceTypeChooser"){
                            if(item.option.value != ""){
                                params[item.key] = item.option.value
                            }
                        }else{
                            if(item.value !== ""){
                                params[item.key] = item.value
                            }
                        }
                    }else{
                        if(item.matchValue != ""){
                            item.searchTypeData.map(function(searchType){
                                if(searchType.paramName == item.matchValue){
                                    if(searchType.value != null && searchType.value != ""){
                                        let types = item.matchValue.split(",")
                                        if(types.length == 1){
                                            if(item.dataType == "time"){
                                                // console.log(searchType)
                                                // params[types[0]] = parseInt(searchType.value.valueOf() / 1000)
                                                if (searchType.key === '之后') {
                                                    params[types[0]] = searchType.value.endOf('day').unix()
                                                } else {
                                                    params[types[0]] = searchType.value.startOf('day').unix()
                                                }
                                            }else{
                                                params[types[0]] = parseFloat(searchType.value)
                                            }
                                        }else{
                                            if(item.dataType == "time"){
                                                params[types[0]] = parseInt(searchType.value[0].valueOf() / 1000)
                                                params[types[1]] = parseInt(searchType.value[1].valueOf() / 1000)
                                            }else{
                                                params[types[0]] = parseFloat(searchType.value[0])
                                                params[types[1]] = parseFloat(searchType.value[1])
                                            }
                                        }
                                    }
                                }
                            })
                        }
                    }
                })
                // console.log(params)
                this.$emit("search",params);
            },
            onSearch() {
                // 此处需要在下一次更新或循环时执行，否则会出现在选择框变化前就提交的问题
                this.$nextTick().then(() => {
                    this.handleSearch()
                })
            },
            orgSelect(org){
                this.$emit("orgSelect",org)
                this.onSearch()
            },
            directChange () {
                this.onSearch()
            },
            openChange(status) {
                // console.log(status)
                // 当是关闭面板的时候执行
                if (status === false) {
                    this.onSearch()
                }
            },
            deviceModelChange () {
                this.onSearch()
            },
            handleReset() {
            },
            toggle() {
                this.expand = !this.expand
            }
        }
    }
</script>
<style lang="less" scoped>
@import '../../theme/page.less';
.ant-form-item {
    padding-bottom: 0 !important;
    margin-bottom: 18px !important;
}
.ant-advanced-search-form {
    .content;
    padding: 20px 20px 0 20px !important;
}
</style>
